import { Typography } from "antd";
import { useEffect, useState } from "react";
import copyIcon from "../../../../common/images/png/Copy.png";
import { ReactComponent as SuccessIcon } from "../../../../common/images/svg/Success.svg";
import { useNotification } from "../../../../components/providers/notification/useNotification";

interface TextContentProps {
  label: string;
  value: string;
  realValue?: string;
  canCopy?: boolean;
  color?: string;
}

const TextContent = ({
  label,
  value,
  realValue = value,
  canCopy = false,
  color = "#ffffff",
}: TextContentProps) => {
  const [copied, setCopied] = useState(false);
  const { open: openNotification } = useNotification();

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(realValue);
    setCopied(true);
    if (openNotification) {
      openNotification?.({
        key: "add_bank_success",
        message: `Copied ${label} successfully!`,
        type: "success",
      });
    }
  };

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  return (
    <div className="content-item">
      <Typography className="text-label">{label}</Typography>
      <div className="text-value-box">
        <Typography
          className="text-value"
          style={{ color, textAlign: "end", maxWidth: "350px" }}
        >
          {value}
        </Typography>
        {canCopy && (
          <>
            {copied ? (
              <SuccessIcon style={{ width: 24, height: 24 }} />
            ) : (
              <img
                alt="copy"
                src={copyIcon}
                className="icon-animation"
                style={{ cursor: "pointer", width: 24, height: 24 }}
                onClick={handleCopy}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TextContent;
